import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { CoderPage } from './pages/CoderPage';
import { CodeBaseIndexPage } from './pages/CodeBaseIndexPage';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
import { Provider } from 'react-redux';
import store from './app/store';
import { CodebasesPage } from './pages/CodebasesPage';
import { WebsocketConnectionsPage } from './pages/WebsocketConnectionsPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const router = createBrowserRouter([
  {
    path: "/",
    element: <CoderPage />,
  },
  {
    path: "/coder",
    element: <CoderPage />,
  },
  {
    path: "/codebase_index",
    element: <CodeBaseIndexPage />,
  },
  {
    path: "/codebases",
    element: <CodebasesPage />,
  },
  {
    path: "/executions",
    element: <WebsocketConnectionsPage />,
  },
]);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
